import React from 'react';
import { CheckIcon } from 'lucide-react';
import { RoomDiagram } from './RoomDiagram';
const parts = ['The session focus, in process language', 'Room setup, optional props and timings for 30, 45 or 60 minutes', 'Opening words and the theme invitation, word for word', 'Warm-Up → Theme → Develop → Close', 'Energy Dial: a low, steady and high version', 'A Seated Swap for every move', '“If the group…” routes, the common error and the fix', 'A closing ritual and optional processing prompts'];
const legend = [{
  dot: 'bg-shuttle',
  label: 'Facilitator'
}, {
  dot: 'bg-white ring-2 ring-ink',
  label: 'Standing'
}, {
  dot: 'bg-green',
  label: 'Seated'
}, {
  dot: 'bg-sky',
  label: 'Wheelchair'
}];

/** Shown in the second review slot until real buyer reviews are added. */
export function SessionAnatomy() {
  return <section aria-labelledby="anatomy-heading" className="w-full bg-light" data-id="element-299" data-mp="1zpo2feujna9h">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-300" data-mp="23qpw7g5oyu42">
        <div className="text-center" data-id="element-301" data-mp="3p244un33punr">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-court-deep" data-id="element-302" data-mp="3p12gjgx2rbo3">
            What you open before the group
          </p>
          <h2 id="anatomy-heading" className="mt-3 font-display font-bold text-ink text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-303" data-mp="3fckkte3njurb">
            Every session answers the questions before you ask them
          </h2>
        </div>

        <div className="mt-9 grid items-center gap-6 md:grid-cols-[.8fr_1.2fr]" data-id="element-304" data-mp="35fpnuzn122f5">
          <div className="mx-auto w-full max-w-[300px] rounded-2xl border border-line bg-white p-4 shadow-card" data-id="element-305" data-mp="31c02sk5ka2yv">
            <RoomDiagram data-id="element-306" data-mp="2we86zf1spwpe" />
            <ul className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-1.5" data-id="element-307" data-mp="2wfjbxi6z9ai3">
              {legend.map(l => <li key={l.label} className="flex items-center gap-1.5 text-[11px] font-bold text-ink-soft" data-id="element-308" data-mp="um3dhz4nerck">
                  <span className={`h-2.5 w-2.5 rounded-full ${l.dot}`} data-id="element-309" data-mp="pmqlz12u0w3n" />
                  {l.label}
                </li>)}
            </ul>
          </div>

          <ul className="grid gap-2.5" data-id="element-310" data-mp="2ou73ygj96acp">
            {parts.map(p => <li key={p} className="flex items-start gap-3 rounded-xl border border-line bg-white px-4 py-3 text-sm font-semibold text-ink" data-id="element-311" data-mp="2ovi84hgm1k4c">
                <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-green" data-id="element-312" data-mp="2f3um4w2tova9">
                  <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-313" data-mp="32toy7bfbiftg" />
                </span>
                {p}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}